import React, { useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  Button,
  CloseButton,
  Box,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import {  updateExpertADP } from "../../../services/http/surveyHttpService";
import { useToast } from "@chakra-ui/react";
const UpdateExpertModal = ({ isOpen, onClose, formDataInput , refreshExpertData }) => {
  const {t} = useTranslation();
  const [formData, setFormData] = useState({});

    const toast = useToast();
  
  useEffect(() => {
    // Effetto collaterale
      setFormData(formDataInput)
      
  }, [formDataInput]); // Array delle dipendenze


  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = () => {
    // Prepara l'oggetto da inviare al backend



    if (
      formDataInput.name === formData.name &&
      formDataInput.surname === formData.surname &&
      formDataInput.email === formData.email
    ) {
      // fai qualcosa
      
      return
    }

   
    if(formData.name && formData.surname && formData.email) {
      console.log(formData)

   
      formData.owner = sessionStorage.getItem("username")
      updateExpertADP(t, formData).then(res => {

        refreshExpertData();
        toast({
          title: "",
          description: res.message,
          position: "bottom",
          status: res.status =="404" ? "error": "info",
          duration: 2000,
          isClosable: true});


          onClose()

      })
    }

    

    
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"xl"} closeOnOverlayClick={false} >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader  bgColor={"#0888BE"} color={"white"} display="flex" justifyContent="space-between">
          <Box>
            {t('survey.expertModal.updateDataOfExpert')}
          </Box>
          <Box>
            <CloseButton onClick={()=>{onClose();}}/>
          </Box>
        </ModalHeader>
        <ModalBody>
  <FormControl>
    <FormLabel>{t('survey.expertModal.name')}</FormLabel>
    <Input
      value={formData.name}
      placeholder={t('survey.expertModal.name')}
      onChange={(e) => handleChange(e, "name")}
    />
  </FormControl>
  
  <FormControl mt={4}>
    <FormLabel>{t('survey.expertModal.surname')}</FormLabel>
    <Input
      value={formData.surname}
      placeholder={t('survey.expertModal.surname')}
      onChange={(e) => handleChange(e, "surname")}
    />
  </FormControl>
  
  

  <FormControl mt={4}>
    <FormLabel>Email</FormLabel>
    <Input
     value={formData.email}
      placeholder="Email"
      onChange={(e) => handleChange(e, "email")}
    />
  </FormControl>
  
  
</ModalBody>

        <ModalFooter>
          <Button colorScheme='green' mr={3} onClick={handleSubmit}>
            {t('survey.expertModal.updateBtn')}
          </Button>
          <Button colorScheme='red' onClick={onClose}>
            {t('survey.expertModal.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UpdateExpertModal;
